import { render } from "./CustomSidebar.vue?vue&type=template&id=6cbcae8f&scoped=true"
import script from "./CustomSidebar.vue?vue&type=script&lang=js"
export * from "./CustomSidebar.vue?vue&type=script&lang=js"

import "./CustomSidebar.vue?vue&type=style&index=0&id=6cbcae8f&lang=css&scoped=true"

import exportComponent from "/Users/numeria/Desktop/innopearl-partner-plus/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cbcae8f"]])

export default __exports__